import { Resources } from 'constants/resources';

import { blue } from '@mui/material/colors';
import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { useRecordContext } from 'react-admin';
import { Link } from 'react-router-dom';
import { Typography } from 'shared/mui/Typography';
import { User } from 'types/embedded/user';

import { StyledAvatar, StyledBox, StyledProfileBox } from './UserProfileField.styled';

export const UserProfileField: React.FC<{ showLink?: boolean }> = ({ showLink }) => {
  const record = useRecordContext<User>();
  const { createPathWithQuery } = useCreatePathWithQuery();

  if (!record) {
    return <></>;
  }

  const fullName = `${record?.firstName} ${record?.lastName}`;

  return (
    <StyledBox>
      <StyledAvatar title={fullName}>
        {`${record?.firstName?.[0]}${record?.lastName?.[0]}`.toUpperCase()}
      </StyledAvatar>
      <StyledProfileBox>
        {showLink ? (
          <Link
            style={{
              color: blue[700],
              fontSize: 14,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
            title={fullName}
            to={createPathWithQuery({ resource: Resources.Users, id: record?.id, type: 'show' })}
          >
            {fullName}
          </Link>
        ) : (
          <Typography fontSize={14} noWrap title={fullName}>
            {fullName}
          </Typography>
        )}
      </StyledProfileBox>
    </StyledBox>
  );
};
